export default __webpack_public_path__ + "static/media/angpao-bm.51ad995c.webp";